// https://tkdodo.eu/blog/effective-react-query-keys#use-query-key-factories

const applianceKeys = {
  all: ['appliance'] as const,
  appliances: (category?: string, searchTerm?: string) =>
    [
      ...applianceKeys.all,
      'appliances',
      category ?? null,
      searchTerm ?? null,
    ] as const,
  solarEquipmentReadiness: () =>
    [...applianceKeys.all, 'solarEquipmentReadiness'] as const,
};

export default applianceKeys;
